import styles from "./CourtSvg.module.css";
import { COURT_VIEWBOX, zones } from "./courtZones.ts";

interface CourtSvgProps {
  showLabels?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function CourtSvg({ showLabels = true, className, children }: CourtSvgProps) {
  return (
    <svg
      viewBox={COURT_VIEWBOX}
      className={`${styles.court} ${className ?? ""}`}
      role="img"
      aria-label="Basketball half-court with 19 zones"
    >
      {zones.map((zone) => (
        <g key={zone.id}>
          <path className={styles.zone} d={zone.path} data-zone={zone.id} />
          {showLabels && (
            <text className={styles.label} x={zone.labelX} y={zone.labelY}>
              {zone.shortLabel}
            </text>
          )}
        </g>
      ))}
      {children}
    </svg>
  );
}
